import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { useCartStore } from '../store/useCartStore';
import { createTranslator, SUPPORTED_LANGUAGES, useLanguage } from '../i18n/LanguageContext';
import { commonTranslations } from '../i18n/translations';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleCart = useCartStore((state) => state.toggleCart);
  const cartItems = useCartStore((state) => state.cartItems);
  const { language, setLanguage } = useLanguage();
  const t = createTranslator(language, commonTranslations);

  const navigationLinks = [
    ['/', 'home'],
    ['/tournamentlist', 'tournament'],
    ['/leaguelist', 'league'],
    ['/leagueclassement', 'leagueRanking'],
    ['/ClassementMendyx', 'mendyxRanking'],
    ['/StageList', 'academy'],
    ['/shop', 'shop'],
    ['/abonnement', 'subscriptions'],
  ];

  const languageSelector = (
    <label className="flex items-center gap-1 text-xs text-gray-600">
      <span className="sr-only">{t('language')}</span>
      <select
        value={language}
        onChange={(event) => setLanguage(event.target.value)}
        aria-label={t('language')}
        className="rounded-md border border-[#4c2f8e]/40 bg-white px-2 py-1 text-[#4c2f8e] focus:outline-none focus:ring-2 focus:ring-[#4c2f8e]/30"
      >
        {SUPPORTED_LANGUAGES.map((code) => (
          <option key={code} value={code}>{code.toUpperCase()}</option>
        ))}
      </select>
    </label>
  );

  return (
    <nav className="bg-white border-b border-[#4c2f8e] shadow-sm fixed top-0 w-full z-50 py-2">
      <div className="container mx-auto flex justify-between items-center px-6">
        {/* Logo à gauche */}
        <Link to="/" className="flex items-center space-x-2">
          <img
            src="/logo2.jfif"
            alt="Mendyx Logo"
            className="h-8 w-8 rounded-full border border-[#4c2f8e] p-1 shadow-md transition-transform duration-500 ease-in-out hover:rotate-6 hover:scale-105"
          />
          <span className="text-xl font-light text-[#4c2f8e] tracking-wide">{t('brand')}</span>
        </Link>

        {/* Menu principal */}
        <div className="flex items-center space-x-6">
          <ul className="hidden md:flex space-x-6 text-sm font-light text-gray-700">
            {navigationLinks.map(([to, key]) => (
              <li key={to}><Link to={to} className="hover:text-[#4c2f8e]">{t(key)}</Link></li>
            ))}
          </ul>

        {/* Panier + Hamburger groupés sur mobile */}
<div className="flex items-center gap-2 md:gap-6">
  {languageSelector}
  <div className="relative md:order-2">
    <button
      onClick={toggleCart}
      aria-label={t('cart')}
      className="relative flex items-center justify-center w-10 h-10 rounded-full border border-[#4c2f8e] text-[#4c2f8e] hover:bg-[#f3edff] transition"
    >
      <ShoppingCart size={20} />
      {cartItems.length > 0 && (
        <span className="absolute -top-1 -right-1 bg-[#ea4c89] text-white text-[10px] w-5 h-5 rounded-full flex items-center justify-center">
          {cartItems.length}
        </span>
      )}
    </button>
  </div>

  <button className="md:hidden text-black" onClick={() => setIsOpen(!isOpen)}>
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
        d={isOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16m-7 6h7'} />
    </svg>
  </button>
</div>

        </div>

        {/* Menu mobile hamburger */}
        
      </div>

      {/* Menu mobile */}
      {isOpen && (
        <div className="md:hidden bg-white text-center py-4 border-t border-[#4c2f8e]">
          <ul className="space-y-4 text-sm font-light text-gray-700">
            {navigationLinks.map(([to, key]) => (
              <li key={to}><Link to={to} onClick={() => setIsOpen(false)}>{t(key)}</Link></li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
